





























































































































































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import StatusStatement from '@/components/statuses/StatusStatement.vue'
import { EStatementStatuses } from '@zunta/configurations'
import TextArea from '@/components/inputs/TextArea.vue'
import Input from '@/components/inputs/Input.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import Icon from '@/components/Icon.vue'
import { helpers, minLength, required, sameAs } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import Select from '@/components/Select.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import ScrollView from '@/components/ScrollView.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Modal from '@/components/Modal.vue'
import RadioGroup from '@/components/RadioGroup.vue'
import { ISelectItem } from '@/interfaces'
import { EAutoPayType } from '@zunta/configurations/dist/types/payments'
import InputPassword from '@/components/inputsV2/InputPassword.vue'

// Component.registerHooks(['validations'])

@Component({
  components: {
    InputPassword,
    RadioGroup,
    Modal,
    ModalV2,
    Checkbox,
    ScrollView,
    MultiSelectV2,
    Select,
    SelectV2,
    TextareaV2,
    InputValidator,
    Icon,
    InputV2,
    SearchInput,
    Input,
    TextArea,
    StatusStatement
  }
})
export default class UiKit extends Vue {
  EStatementStatuses: any = EStatementStatuses
  selectedStatuses: any = []

  password: any = ''
  passwordConfirm: any = ''

  testValReq: any = ''
  testMultiselect: any = null
  testMultiselect2: any = []

  checkbox: boolean = false
  radio: any = null

  showModal: boolean = false
  showModalV2: boolean = false

  get typeRadioOptions (): ISelectItem[] {
    return [
      {
        key: EAutoPayType.BILL_MAX_ONLY,
        value: EAutoPayType.BILL_MAX_ONLY,
        content: 'Bill account balance. Maximum single payment amount of:'
      },
      {
        key: EAutoPayType.BILL_ANYWAY,
        value: EAutoPayType.BILL_ANYWAY,
        content: 'Bill flat amount (if balance at time of payment is 0, payment will be credited to future charges)'
      },
      {
        key: EAutoPayType.BILL_MONTH_DUE,
        value: EAutoPayType.BILL_MONTH_DUE,
        content: 'Bill balance of month'
      }
    ]
  }

  validations (): any {
    return {
      password: {
        required,
        minLength: minLength(8),
        hasNumber: helpers.regex('hasNumber', /\d/),
        hasUpperLetter: helpers.regex('hasUpperLetter', /[A-Z]/)
      },
      passwordConfirm: {
        passwordMatch: sameAs(() => this.password)
      },
      testValReq: {
        required,
        minLength: minLength(2)
      },
      testMultiselect: { required },
      testMultiselect2: {
        required,
        minLength: minLength(2)
      },
      checkbox: {
        required: sameAs(() => true)
      },
      radio: {
        required
      }
    }
  }

  get statuses () {
    return [
      {
        key: 'active',
        value: 'active',
        content: 'Active'
      },
      {
        key: 'inactive',
        value: 'NOT_ACTIVE',
        content: 'Inactive'
      },
      {
        key: 'test',
        value: 'test',
        content: 'Test'
      },
      {
        key: 'test2',
        value: 'test2',
        content: 'Test 2'
      },
      {
        key: 'test 3',
        value: 'test 3',
        content: 'Test 3'
      },
      {
        key: 'test 4',
        value: 'test 4',
        content: 'Test some kind of long text'
      },
      {
        key: 'test 5',
        value: 'test 5',
        content: 'Test 5'
      },
      {
        key: 'test 6',
        value: 'test 6',
        content: 'Test 6'
      }
    ]
  }

  selectStatuses (statuses: string[]) {
    this.selectedStatuses = statuses
  }

  testFormSubmit () {
    console.log('form submit', this.testValReq, this.testMultiselect)
  }

  test () {

  }

  testSub2 () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      console.log('invalid')
      return false
    }
    console.log('valid')
    return true
  }
}
